import { useContext, useState } from "react";
import { confirmDialog } from "primereact/confirmdialog";
import UiContext from "../../../store/ui-context";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import { apiUrl, editorDefaultValue } from "../utils/problemConstants";

// Editor dialog, image preview, delete confirm and "Lihat Cek" of the problem page.
//   list: what useProblemList gives back
//   config: { pengecekanUrl, auditUrl } of the variant
const useProblemEditor = ({ config, list }) => {
  const uiContext = useContext(UiContext);
  const { loading: editorLoading, requestPost: editorRequestPost } =
    useAPIRequest();

  const {
    loading,
    selectedData,
    setSelectedData,
    fetchData,
    deleteData,
    addProblem,
    replaceProblem,
  } = list;

  const [addNewMode, setAddNewMode] = useState(false);
  const [editorData, setEditorData] = useState({});
  const [editorError, setEditorError] = useState({});
  const [editorDialogShowed, setEditorDialogShowed] = useState(false);
  const [showImagePreview, setShowImagePreview] = useState(false);

  // API call section

  const saveData = async ({ data }) => {
    resetEditorError();
    if (loading) return;
    const valid = validateData();

    if (valid) {
      const body = convertSaveData(data);

      return editorRequestPost({
        fullUrl: `/api/problem/${apiUrl}/save`,
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
          setEditorError(data);
        },
        onSuccess: ({ data, message }) => {
          uiContext.showSuccessMsg("Success", message);
          // fetchListData(paging);
        },
      });
    }
    return null;
  };

  // methods & functions section

  const resetEditorError = () => {
    setEditorError({});
  };

  const validateData = () => {
    let valid = true;
    return valid;
  };

  const convertSaveData = (data) => {
    return data;
  };

  // handle UI events section

  const handleOnDelete = (row) => {
    resetEditorError();
    const accept = async () => {
      if (loading) return;

      await deleteData({ ids: [row.id] });
    };
    const reject = () => {};

    confirmDialog({
      message: "Menghapus 1 data, lanjutkan?",
      header: "Konfirmasi",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const handleDeleteMultiple = () => {
    resetEditorError();

    if (selectedData.length > 0) {
      const accept = async () => {
        if (loading) return;

        const listIds = selectedData.map((el) => el.id);
        await deleteData({ ids: listIds });
        setSelectedData([]);
      };
      const reject = () => {};

      confirmDialog({
        message: `Menghapus ${selectedData.length} data, lanjutkan?`,
        header: "Konfirmasi",
        icon: "pi pi-exclamation-triangle",
        acceptClassName: "p-button-danger",
        accept,
        reject,
      });
    }
  };

  const handleOnAddNew = () => {
    setAddNewMode(true);
    resetEditorError();
    setEditorData({ ...editorDefaultValue });
    setEditorDialogShowed(true);
  };

  const handleOnEdit = async (row) => {
    setAddNewMode(false);
    resetEditorError();
    const newData = await fetchData({ id: row.id });
    if (newData) {
      setEditorData({ ...newData });
      setEditorDialogShowed(true);
    }
  };

  const handleConfirmEditor = async (data) => {
    const newData = await saveData({ data });
    if (newData) {
      if (addNewMode) {
        addProblem(newData);
      } else {
        replaceProblem(newData);
      }
      setEditorDialogShowed(false);
    }
  };

  const handleOnClickImage = (row) => {
    setEditorData({ ...row });
    setShowImagePreview(true);
  };

  // open the pengecekan / audit the problem came from
  const handleOnClickShowPengecekan = (row) => {
    if (
      row.data_pengecekan_mobil_detil &&
      row.data_pengecekan_mobil_detil.data_pengecekan_mobil &&
      row.data_pengecekan_mobil_detil.data_pengecekan_mobil.pemakaian_mobil_id
    ) {
      const id =
        row.data_pengecekan_mobil_detil.data_pengecekan_mobil
          .pemakaian_mobil_id;
      if (id > 0) {
        window.open(config.pengecekanUrl(id), "_blank");
      }
    }
    if (
      row.data_audit_kendaraan_detil &&
      row.data_audit_kendaraan_detil.audit_kendaraan_id
    ) {
      const id = row.data_audit_kendaraan_detil.audit_kendaraan_id;
      if (id > 0) {
        window.open(config.auditUrl(id), "_blank");
      }
    }
  };

  return {
    editorLoading,
    addNewMode,
    editorData,
    setEditorData,
    editorError,
    setEditorError,
    editorDialogShowed,
    setEditorDialogShowed,
    showImagePreview,
    setShowImagePreview,
    handleOnDelete,
    handleDeleteMultiple,
    handleOnAddNew,
    handleOnEdit,
    handleConfirmEditor,
    handleOnClickImage,
    handleOnClickShowPengecekan,
  };
};

export default useProblemEditor;
